
const m = window.require("@ember/engine/instance");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
